/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { NotifierService } from './notifier/notifier.service';
import { DataTableSortType } from './sort.type';
import { DataTableFooterComponent } from './table.footer.component';
import { DataTableHeaderComponent } from './table.header.component';
import { DataTableInfoHeaderComponent } from './table.info.header.component';
import * as i0 from "@angular/core";
import * as i1 from "./table.utils";
import * as i2 from "@angular/common";
import * as i3 from "./notifier/aria-notifier.component";
import * as i4 from "./table.header.component";
import * as i5 from "./table.info.header.component";
import * as i6 from "./table.footer.component";
import * as i7 from "./table.body.component";
const _c0 = ["headerLeft"];
const _c1 = ["headerRight"];
const _c2 = ["footerLeft"];
const _c3 = ["footerRight"];
function DataTableComponent_div_0_ng_container_1_DataTable_table_aria_notifier_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "DataTable-table-aria-notifier", 12);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("notifierService", ctx_r3.notifierService)("tableId", ctx_r3.tableId);
} }
function DataTableComponent_div_0_ng_container_1_DataTable_table_info_header_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "DataTable-table-info-header", 13);
    i0.ɵɵlistener("filterChange", function DataTableComponent_div_0_ng_container_1_DataTable_table_info_header_2_Template_DataTable_table_info_header_filterChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r9.headerChange($event)); })("columnChange", function DataTableComponent_div_0_ng_container_1_DataTable_table_info_header_2_Template_DataTable_table_info_header_columnChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r11.updateCurrentColumns($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("serverSideData", ctx_r4.serverSideData)("filterable", ctx_r4.filterable)("columnFiltering", ctx_r4.columnFiltering)("columnPicker", ctx_r4.columnPicker)("columns", ctx_r4.currentColumns)("allColumns", ctx_r4.columns)("filter", ctx_r4.filter)("showFilterPlaceholders", ctx_r4.showFilterPlaceholders)("localPagingSize", ctx_r4.localPagingSize)("notifierService", ctx_r4.notifierService)("tableId", ctx_r4.tableId)("leftSideHeaderTemplate", ctx_r4.headerLeftTemplate)("rightSideHeaderTemplate", ctx_r4.headerRightTemplate);
} }
function DataTableComponent_div_0_ng_container_1_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.sortMessage, " ");
} }
function DataTableComponent_div_0_ng_container_1_p_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("screen-reader", ctx_r6.hideCaption);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.sortMessage);
} }
function DataTableComponent_div_0_ng_container_1_thead_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "thead", 15);
    i0.ɵɵlistener("sortChange", function DataTableComponent_div_0_ng_container_1_thead_10_Template_thead_sortChange_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.changeSort($event.property, $event.sortType)); })("filterChange", function DataTableComponent_div_0_ng_container_1_thead_10_Template_thead_filterChange_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r14.headerChange($event)); })("columnChange", function DataTableComponent_div_0_ng_container_1_thead_10_Template_thead_columnChange_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r15.updateCurrentColumns($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tableId", ctx_r7.tableId)("sortable", ctx_r7.sortable)("allColumns", ctx_r7.columns)("currentColumns", ctx_r7.currentColumns)("columnOrdering", ctx_r7.columnOrdering)("childRows", ctx_r7.childRows)("page", ctx_r7.page)("filterable", ctx_r7.filterable)("columnFiltering", ctx_r7.columnFiltering)("localPagingSize", ctx_r7.localPagingSize)("filter", ctx_r7.filter)("showFilterPlaceholders", ctx_r7.showFilterPlaceholders)("notifierService", ctx_r7.notifierService);
} }
function DataTableComponent_div_0_ng_container_1_DataTable_table_footer_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "DataTable-table-footer", 16);
    i0.ɵɵlistener("filterChange", function DataTableComponent_div_0_ng_container_1_DataTable_table_footer_12_Template_DataTable_table_footer_filterChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.headerChange($event)); })("paginationChange", function DataTableComponent_div_0_ng_container_1_DataTable_table_footer_12_Template_DataTable_table_footer_paginationChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.changePage($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("page", ctx_r8.page)("currentColumns", ctx_r8.currentColumns)("allColumns", ctx_r8.columns)("filter", ctx_r8.filter)("localPaging", ctx_r8.localPaging)("localPagingSize", ctx_r8.localPagingSize)("localPagingOptions", ctx_r8.localPagingOptions)("showLocalPagingOptions", ctx_r8.showLocalPagingOptions)("notifierService", ctx_r8.notifierService)("tableId", ctx_r8.tableId)("leftSideFooterTemplate", ctx_r8.footerLeftTemplate)("rightSideFooterTemplate", ctx_r8.footerRightTemplate);
} }
function DataTableComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableComponent_div_0_ng_container_1_DataTable_table_aria_notifier_1_Template, 1, 2, "DataTable-table-aria-notifier", 4);
    i0.ɵɵtemplate(2, DataTableComponent_div_0_ng_container_1_DataTable_table_info_header_2_Template, 1, 13, "DataTable-table-info-header", 5);
    i0.ɵɵtemplate(3, DataTableComponent_div_0_ng_container_1_p_3_Template, 2, 1, "p", 6);
    i0.ɵɵelementStart(4, "div", 7)(5, "table")(6, "caption")(7, "p");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DataTableComponent_div_0_ng_container_1_p_9_Template, 2, 3, "p", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, DataTableComponent_div_0_ng_container_1_thead_10_Template, 1, 13, "thead", 9);
    i0.ɵɵelement(11, "tbody", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, DataTableComponent_div_0_ng_container_1_DataTable_table_footer_12_Template, 1, 12, "DataTable-table-footer", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.suppressAnnouncement);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.serverSideData || ctx_r2.filterable && !ctx_r2.columnFiltering || ctx_r2.columnPicker || ctx_r2.headerLeftTemplate || ctx_r2.headerRightTemplate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.sortMessage && ctx_r2.hideCaption);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("visible", !ctx_r2.hideCaption);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("screen-reader", ctx_r2.hideCaption);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.caption);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.sortMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.page.content && ctx_r2.page.content.length !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("currentColumns", ctx_r2.currentColumns)("columns", ctx_r2.columns)("localFilter", ctx_r2.localFilter)("localPaging", ctx_r2.localPaging)("columnFiltering", ctx_r2.columnFiltering)("filter", ctx_r2.filter)("childRows", ctx_r2.childRows)("childComponent", ctx_r2.childComponent)("sortable", ctx_r2.sortable)("linkTarget", ctx_r2.linkTarget)("linkKey", ctx_r2.linkKey)("page", ctx_r2.page)("tableEmptyMessage", ctx_r2.tableEmptyMessage)("rowStylingFunction", ctx_r2.rowStylingFunction)("cellStylingFunction", ctx_r2.cellStylingFunction);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.footer && ctx_r2.currentColumns.length > 0);
} }
function DataTableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, DataTableComponent_div_0_ng_container_1_Template, 13, 26, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate2("DataTable-table ", ctx_r0.tableCssClass, " ", !(ctx_r0.page == null ? null : ctx_r0.page.content) || ((ctx_r0.page == null ? null : ctx_r0.page.content == null ? null : ctx_r0.page.content.length) || 0) === 0 ? "empty-table" : "", "");
    i0.ɵɵpropertyInterpolate1("id", "DataTable-table-", ctx_r0.tableId, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.page);
} }
function DataTableComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.tableEmptyMessage, " ");
} }
export class DataTableComponent {
    constructor(tableUtils) {
        this.tableUtils = tableUtils;
        this.notifierService = new NotifierService();
        /**
         * An ID for this table, defaults to `uuid.substring(0, 5)`
         */
        this.tableId = uuid().substring(0, 5);
        this.currentColumns = [];
        /**
         * The <caption> text for this table
         */
        this.caption = 'A Data Table';
        /**
         * Whether or not the table <caption> should be hidden (screen-reader) only.
         */
        this.hideCaption = false;
        /**
         * Allow users to turn columns on and off
         */
        this.columnPicker = false;
        /**
         * Allow users to reorder columns with header buttons
         */
        this.columnOrdering = false;
        /**
         * Enables the sorting headers
         */
        this.sortable = true;
        /**
         * Enables the global filter text box
         */
        this.filterable = true;
        /**
         * Enables column specific filter boxes
         */
        this.columnFiltering = false;
        /**
         * Enables client-side filtering as opposed to just emitting a `DataTablePageChangeEvent`
         */
        this.localFilter = true;
        /**
         * Enables the placeholder text for the filter boxes
         */
        this.showFilterPlaceholders = true;
        /**
         * Enables client-side pagination as opposed to just emitting a `DataTablePageChangeEvent`
         */
        this.localPaging = true;
        /**
         * The size of each page
         */
        this.localPagingSize = 10;
        /**
         * The supported page sizes
         */
        this.localPagingOptions = [10, 20, 100];
        /**
         * Enables the drop down for changing the page size
         */
        this.showLocalPagingOptions = true;
        /**
         * Shows a button that when clicked, emits a `DataTablePageChangeEvent`
         */
        this.serverSideData = false;
        /**
         * Enables children rows
         */
        this.childRows = false;
        /**
         * {@link DataTablePageChangeEvent} events are emitted from here
         */
        this.pageChange = new EventEmitter();
        /**
         * The column metadata is emitted from here whenever it changes
         */
        this.columnChange = new EventEmitter();
        /**
         * Disable the column change event, if needed, for performance reasons
         */
        this.disableColumnChangeEvent = false;
        /**
         * Show the footer with 'Showing x through y of z rows`
         */
        this.footer = true;
        /**
         * Message to show when the table is empty
         */
        this.tableEmptyMessage = 'This table contains no rows';
        /**
         * If true, display empty table message as paragraph rather than table cell
         */
        this.tableEmptyAsPlainText = false;
        /**
         * If true, aria-live on notifier component will be removed
         */
        this.suppressAnnouncement = false;
        this.sortMessage = '';
        this.rowStylingFunction = (row) => ({});
    }
    ngOnInit() {
        this.updatePage();
    }
    ngOnChanges(changes) {
        const dataChange = changes.data;
        const columnChange = changes.columns;
        if (columnChange && columnChange.isFirstChange()) {
            this.columns = columnChange.currentValue;
            this.columns.forEach((column) => {
                if (!column.hasOwnProperty('displayed')) {
                    column.displayed = true;
                }
            });
            this.updateCurrentColumns(this.columns, false);
        }
        if (dataChange && !dataChange.isFirstChange()) {
            this.updatePage();
        }
        if (columnChange && !columnChange.isFirstChange()) {
            const columns = this.columns;
            this.updateCurrentColumns(columns);
        }
    }
    ngOnDestroy() {
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
        if (this.localSubscription) {
            this.localSubscription.unsubscribe();
        }
    }
    updateCurrentColumns(newColumns, emitPageEvent = true) {
        this.currentColumns = newColumns.filter((value) => value.displayed);
        this.columns = newColumns;
        if (emitPageEvent) {
            this.emitCurrent();
        }
        this.publishColumnChangeEvent();
    }
    changePage(pageNo) {
        this.pageChange.emit({
            pageNo,
            columns: this.currentColumns,
            sortString: this.generateSortString(),
            sorts: this.generateSortArray(),
            filter: this.filter,
        });
    }
    /**
     * Emits a {@link DataTablePageChangeEvent} with the current information. This event should be consumed by the host
     * component and sent to a REST endpoint to update the data.
     */
    emitCurrent() {
        var _a;
        this.changePage((_a = this.page.number) !== null && _a !== void 0 ? _a : 0);
    }
    headerChange(event) {
        this.columns = event.columns;
        this.currentColumns = this.columns.filter((value) => value.displayed);
        this.filter = event.filter;
        this.localPagingSize = event.localPagingSize;
        this.changePage(0);
    }
    changeSort(columnProperty, sortType, resetOthers = true) {
        var _a;
        if (this.sortable) {
            if (resetOthers) {
                this.currentColumns.forEach((column) => {
                    column.sortType = DataTableSortType.NONE;
                });
            }
            this.currentColumns.forEach((column) => {
                if (column.property === columnProperty) {
                    // State Machine
                    // NONE --> ASC -> DESC -> ASC
                    switch (sortType) {
                        case DataTableSortType.NONE: {
                            // -> ASC
                            column.sortType = DataTableSortType.ASC;
                            break;
                        }
                        case DataTableSortType.ASC: {
                            // -> DESC
                            column.sortType = DataTableSortType.DESC;
                            break;
                        }
                        case DataTableSortType.DESC:
                        default: {
                            // -> ASC
                            column.sortType = DataTableSortType.ASC;
                            break;
                        }
                    }
                    this.sortMessage = this.getSortMessage(column);
                    this.notifierService.postMessage(this.sortMessage);
                }
            });
            const sorts = this.generateSortArray();
            if (!this.serverSideData) {
                // sort internally
                this.sort((_a = this.page.content) !== null && _a !== void 0 ? _a : [], sorts);
            }
            this.pageChange.emit({
                pageNo: this.page.number || 0,
                columns: this.currentColumns,
                sortString: this.generateSortString(),
                sorts,
                filter: this.filter,
            });
            this.publishColumnChangeEvent();
        }
    }
    getSortMessage(column) {
        let message = `Sorted by ${column === null || column === void 0 ? void 0 : column.header}: `;
        if ((column === null || column === void 0 ? void 0 : column.sortType) === DataTableSortType.DESC) {
            message += 'Descending';
        }
        else if ((column === null || column === void 0 ? void 0 : column.sortType) === DataTableSortType.ASC) {
            message += 'Ascending';
        }
        else {
            message += 'Unsorted';
        }
        return message;
    }
    /**
     * Currently only works if your input is an any[], returns the current "view" into the table with filtering/column selection
     *
     * @param rendered If you would like inline pipes to be applied to the exported data
     */
    exportCurrentData(rendered = true) {
        let currentData;
        if (this.localFilter &&
            ((this.columnFiltering && this.tableUtils.hasFilter(this.currentColumns)) ||
                (this.filter && this.filter.length > 0))) {
            currentData = this.tableUtils.filter(this.data, this.currentColumns, this.columnFiltering, this.filter);
            this.sort(currentData, this.generateSortArray());
        }
        else {
            currentData = this.data;
        }
        if (this.currentColumns.length === 0) {
            return {
                data: [],
                columns: [],
            };
        }
        return {
            data: currentData.map((row) => this.tableUtils.exportRow(row, this.currentColumns, rendered)),
            columns: this.currentColumns,
        };
    }
    publishColumnChangeEvent() {
        if (!this.disableColumnChangeEvent) {
            this.columnChange.emit({
                columns: this.columns,
                currentSortString: this.generateSortString(),
            });
        }
    }
    generateSortString() {
        let sortString = '';
        this.currentColumns.forEach((column) => {
            switch (column.sortType) {
                case DataTableSortType.ASC: {
                    sortString += '' + column.property + ';';
                    break;
                }
                case DataTableSortType.DESC: {
                    sortString += '-' + column.property + ';';
                    break;
                }
                case DataTableSortType.NONE: {
                    break;
                }
            }
        });
        return sortString;
    }
    generateSortArray() {
        const currentSorts = [];
        this.currentColumns.forEach((column) => {
            switch (column.sortType) {
                case DataTableSortType.ASC:
                case DataTableSortType.DESC: {
                    currentSorts.push({ property: column.property, sortType: column.sortType });
                    break;
                }
            }
        });
        return currentSorts;
    }
    sort(content, sorts) {
        const columnCache = {};
        this.columns.forEach((column) => (columnCache[column.property] = column));
        content.sort((a, b) => {
            let result = 0;
            sorts.forEach((sort) => {
                if (result === 0) {
                    const aVal = this.tableUtils.findValue(a, sort.property);
                    const bVal = this.tableUtils.findValue(b, sort.property);
                    const sortFunction = columnCache[sort.property].ascendingSortFunction;
                    if (!!sortFunction) {
                        result = sortFunction(aVal, bVal);
                    }
                    else if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
                        result = aVal - bVal;
                    }
                    else {
                        result = aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
                    }
                    result *= sort.sortType === DataTableSortType.DESC ? -1 : 1;
                }
            });
            return result;
        });
    }
    updatePage() {
        if (this.data) {
            if (this.data.constructor === Array) {
                this.setupPageArray();
            }
            else if (this.data.constructor === Observable) {
                this.setupPageSubscription();
            }
            else {
                this.page = this.data;
                if (!this.page.number) {
                    this.page.number = 0;
                }
            }
            this.setupInitialSort();
        }
    }
    filterContent(event) {
        var _a;
        return this.tableUtils.filter(this.data, this.currentColumns, this.columnFiltering, (_a = event.filter) !== null && _a !== void 0 ? _a : '');
    }
    updateLocalPage(event) {
        var _a;
        let content;
        if ((event.filter && event.filter.length > 0) || this.tableUtils.hasFilter(event.columns)) {
            content = this.filterContent(event);
        }
        else {
            content = this.data;
        }
        this.sort(content, (_a = event.sorts) !== null && _a !== void 0 ? _a : []);
        const total = content.length;
        // IntelliJ claims this * 1 call is useless, but we need to make sure it's a number
        const pageSize = this.localPaging
            ? (this.localPagingSize > content.length ? content.length : this.localPagingSize) * 1
            : content.length;
        const pageCount = total === 0 ? 0 : Math.ceil(total / pageSize);
        const pageNo = event.pageNo + 1 > pageCount || content.length <= pageSize ? 0 : event.pageNo;
        const sliceRange = pageSize * pageNo + pageSize;
        const displayedContent = content.slice(pageSize * pageNo, sliceRange);
        this.page = {
            number: pageNo,
            totalPages: pageCount,
            totalElements: total,
            first: pageNo === 0,
            last: pageNo + 1 === pageCount,
            numberOfElements: pageSize,
            content: displayedContent,
        };
    }
    calculateLocalPageNoPagination(event) {
        if ((event.filter && event.filter.length > 0) || this.tableUtils.hasFilter(event.columns)) {
            const filteredContent = this.filterContent(event);
            this.page = {
                number: 0,
                totalPages: 1,
                totalElements: filteredContent.length,
                first: true,
                last: false,
                numberOfElements: filteredContent.length,
                content: filteredContent,
            };
        }
        else {
            this.page = this.createLocalPage();
        }
    }
    createLocalPage(data) {
        const total = (data ? data : this.data).length;
        return {
            number: 0,
            totalPages: 1,
            totalElements: total,
            first: true,
            last: true,
            numberOfElements: total,
            content: data ? data : this.data,
        };
    }
    setupPageArray() {
        if (this.localPaging) {
            if (this.localSubscription) {
                this.localSubscription.unsubscribe();
            }
            this.localSubscription = this.pageChange.subscribe((event) => this.updateLocalPage(event));
            this.pageChange.emit({
                pageNo: 0,
                columns: this.currentColumns,
                sortString: this.generateSortString(),
                sorts: this.generateSortArray(),
                filter: this.filter,
            });
        }
        else {
            this.page = this.createLocalPage();
            if (this.localFilter) {
                if (this.localSubscription) {
                    this.localSubscription.unsubscribe();
                }
                this.localSubscription = this.pageChange.subscribe((event) => this.calculateLocalPageNoPagination(event));
            }
        }
    }
    setupPageSubscription() {
        // Fix potential memory leak, by unsubscribing to previous subscription if exists
        if (this.dataSubscription) {
            this.dataSubscription.unsubscribe();
        }
        this.dataSubscription = this.data.subscribe((data) => {
            if (data.constructor === Array) {
                const content = data;
                const total = content.length;
                this.sort(content, this.generateSortArray());
                this.page = {
                    number: 0,
                    totalPages: 1,
                    totalElements: total,
                    first: true,
                    last: true,
                    numberOfElements: total,
                    content: content,
                };
            }
            else {
                this.page = data;
            }
        });
    }
    setupInitialSort() {
        const { NONE } = DataTableSortType;
        if (this.initialSort) {
            const sorts = this.initialSort.split(';');
            sorts.forEach((sort) => {
                this.columns.forEach((column) => {
                    let type = DataTableSortType.NONE;
                    let property = sort;
                    if (sort.startsWith('-')) {
                        type = DataTableSortType.DESC;
                        property = property.substr(1);
                    }
                    else {
                        type = DataTableSortType.ASC;
                    }
                    if (property === column.property) {
                        column.sortType = type;
                    }
                });
            });
            this.changeSort('', NONE, false);
            if (sorts.length === 1) {
                const column = this.currentColumns.find((col) => col.property === sorts[0] || '-' + col.property === sorts[0]);
                this.sortMessage = this.getSortMessage(column);
                this.notifierService.postMessage(this.sortMessage);
            }
        }
        if (this.page.sorts && this.page.sorts.length > 0) {
            this.columns.forEach((column) => {
                const pageSort = this.page.sorts || [];
                pageSort.forEach((sort) => {
                    if (column.property === sort.property) {
                        column.sortType = DataTableSortType.NONE;
                        if (sort.ascending) {
                            column.sortType = DataTableSortType.ASC;
                        }
                        else if (sort.descending) {
                            column.sortType = DataTableSortType.DESC;
                        }
                    }
                });
            });
            if (!this.serverSideData) {
                this.changeSort('', NONE, false);
            }
        }
    }
    displayTableEmptyAsPlainText() {
        var _a, _b, _c;
        return this.tableEmptyAsPlainText && (!((_a = this.page) === null || _a === void 0 ? void 0 : _a.content) || (((_c = (_b = this.page) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.length) || 0) === 0);
    }
}
DataTableComponent.ɵfac = function DataTableComponent_Factory(t) { return new (t || DataTableComponent)(i0.ɵɵdirectiveInject(i1.DataTableUtils)); };
DataTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableComponent, selectors: [["mhe-datatable"]], contentQueries: function DataTableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, _c0, 7);
        i0.ɵɵcontentQuery(dirIndex, _c1, 7);
        i0.ɵɵcontentQuery(dirIndex, _c2, 7);
        i0.ɵɵcontentQuery(dirIndex, _c3, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerLeftTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerRightTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerLeftTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerRightTemplate = _t.first);
    } }, viewQuery: function DataTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(DataTableInfoHeaderComponent, 5);
        i0.ɵɵviewQuery(DataTableHeaderComponent, 5);
        i0.ɵɵviewQuery(DataTableFooterComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerInfoComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerComponent = _t.first);
    } }, inputs: { tableId: "tableId", tableCssClass: "tableCssClass", data: "data", columns: "columns", caption: "caption", hideCaption: "hideCaption", columnPicker: "columnPicker", columnOrdering: "columnOrdering", linkTarget: "linkTarget", linkKey: "linkKey", sortable: "sortable", filterable: "filterable", columnFiltering: "columnFiltering", localFilter: "localFilter", showFilterPlaceholders: "showFilterPlaceholders", localPaging: "localPaging", localPagingSize: "localPagingSize", localPagingOptions: "localPagingOptions", showLocalPagingOptions: "showLocalPagingOptions", serverSideData: "serverSideData", initialSort: "initialSort", cellStylingFunction: "cellStylingFunction", childRows: "childRows", childComponent: "childComponent", disableColumnChangeEvent: "disableColumnChangeEvent", filter: "filter", footer: "footer", tableEmptyMessage: "tableEmptyMessage", tableEmptyAsPlainText: "tableEmptyAsPlainText", suppressAnnouncement: "suppressAnnouncement", rowStylingFunction: "rowStylingFunction" }, outputs: { pageChange: "pageChange", columnChange: "columnChange" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "class", "id", 4, "ngIf"], ["class", "empty-table", 4, "ngIf"], [3, "id"], [4, "ngIf"], [3, "notifierService", "tableId", 4, "ngIf"], [3, "serverSideData", "filterable", "columnFiltering", "columnPicker", "columns", "allColumns", "filter", "showFilterPlaceholders", "localPagingSize", "notifierService", "tableId", "leftSideHeaderTemplate", "rightSideHeaderTemplate", "filterChange", "columnChange", 4, "ngIf"], ["aria-hidden", "true", "class", "dataTable-sort-message", 4, "ngIf"], [1, "table-wrapper"], [3, "screen-reader", 4, "ngIf"], ["DataTable-table-header", "", 3, "tableId", "sortable", "allColumns", "currentColumns", "columnOrdering", "childRows", "page", "filterable", "columnFiltering", "localPagingSize", "filter", "showFilterPlaceholders", "notifierService", "sortChange", "filterChange", "columnChange", 4, "ngIf"], ["DataTable-table-body", "", 3, "currentColumns", "columns", "localFilter", "localPaging", "columnFiltering", "filter", "childRows", "childComponent", "sortable", "linkTarget", "linkKey", "page", "tableEmptyMessage", "rowStylingFunction", "cellStylingFunction"], [3, "page", "currentColumns", "allColumns", "filter", "localPaging", "localPagingSize", "localPagingOptions", "showLocalPagingOptions", "notifierService", "tableId", "leftSideFooterTemplate", "rightSideFooterTemplate", "filterChange", "paginationChange", 4, "ngIf"], [3, "notifierService", "tableId"], [3, "serverSideData", "filterable", "columnFiltering", "columnPicker", "columns", "allColumns", "filter", "showFilterPlaceholders", "localPagingSize", "notifierService", "tableId", "leftSideHeaderTemplate", "rightSideHeaderTemplate", "filterChange", "columnChange"], ["aria-hidden", "true", 1, "dataTable-sort-message"], ["DataTable-table-header", "", 3, "tableId", "sortable", "allColumns", "currentColumns", "columnOrdering", "childRows", "page", "filterable", "columnFiltering", "localPagingSize", "filter", "showFilterPlaceholders", "notifierService", "sortChange", "filterChange", "columnChange"], [3, "page", "currentColumns", "allColumns", "filter", "localPaging", "localPagingSize", "localPagingOptions", "showLocalPagingOptions", "notifierService", "tableId", "leftSideFooterTemplate", "rightSideFooterTemplate", "filterChange", "paginationChange"], [1, "empty-table"]], template: function DataTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DataTableComponent_div_0_Template, 2, 6, "div", 0);
        i0.ɵɵtemplate(1, DataTableComponent_div_1_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.displayTableEmptyAsPlainText());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayTableEmptyAsPlainText());
    } }, dependencies: [i2.NgIf, i3.AriaNotifierComponent, i4.DataTableHeaderComponent, i5.DataTableInfoHeaderComponent, i6.DataTableFooterComponent, i7.DataTableBodyComponent], styles: ["\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'mhe-datatable', template: `
    <div
      *ngIf="!displayTableEmptyAsPlainText()"
      class="DataTable-table {{ tableCssClass }} {{
        !page?.content || (page?.content?.length || 0) === 0 ? 'empty-table' : ''
      }}"
      id="DataTable-table-{{ tableId }}"
    >
      <ng-container *ngIf="page">
        <DataTable-table-aria-notifier
          *ngIf="!suppressAnnouncement"
          [notifierService]="notifierService"
          [tableId]="tableId"
        ></DataTable-table-aria-notifier>
        <DataTable-table-info-header
          *ngIf="
            serverSideData ||
            (filterable && !columnFiltering) ||
            columnPicker ||
            headerLeftTemplate ||
            headerRightTemplate
          "
          [serverSideData]="serverSideData"
          [filterable]="filterable"
          [columnFiltering]="columnFiltering"
          [columnPicker]="columnPicker"
          [columns]="currentColumns"
          [allColumns]="columns"
          [filter]="filter"
          [showFilterPlaceholders]="showFilterPlaceholders"
          [localPagingSize]="localPagingSize"
          [notifierService]="notifierService"
          [tableId]="tableId"
          [leftSideHeaderTemplate]="headerLeftTemplate"
          [rightSideHeaderTemplate]="headerRightTemplate"
          (filterChange)="headerChange($event)"
          (columnChange)="updateCurrentColumns($event)"
        ></DataTable-table-info-header>
        <p *ngIf="sortMessage && hideCaption" aria-hidden="true" class="dataTable-sort-message">
          {{ sortMessage }}
        </p>
        <div class="table-wrapper">
          <table>
            <caption [class.visible]="!hideCaption">
              <p [class.screen-reader]="hideCaption">{{ caption }}</p>
              <p [class.screen-reader]="hideCaption" *ngIf="sortMessage">{{ sortMessage }}</p>
            </caption>
            <thead
              *ngIf="page.content && page.content.length !== 0"
              DataTable-table-header
              [tableId]="tableId"
              [sortable]="sortable"
              [allColumns]="columns"
              [currentColumns]="currentColumns"
              [columnOrdering]="columnOrdering"
              [childRows]="childRows"
              [page]="page"
              [filterable]="filterable"
              [columnFiltering]="columnFiltering"
              [localPagingSize]="localPagingSize"
              [filter]="filter"
              [showFilterPlaceholders]="showFilterPlaceholders"
              [notifierService]="notifierService"
              (sortChange)="changeSort($event.property, $event.sortType)"
              (filterChange)="headerChange($event)"
              (columnChange)="updateCurrentColumns($event)"
            ></thead>
            <tbody
              DataTable-table-body
              [currentColumns]="currentColumns"
              [columns]="columns"
              [localFilter]="localFilter"
              [localPaging]="localPaging"
              [columnFiltering]="columnFiltering"
              [filter]="filter"
              [childRows]="childRows"
              [childComponent]="childComponent"
              [sortable]="sortable"
              [linkTarget]="linkTarget"
              [linkKey]="linkKey"
              [page]="page"
              [tableEmptyMessage]="tableEmptyMessage"
              [rowStylingFunction]="rowStylingFunction"
              [cellStylingFunction]="cellStylingFunction"
            ></tbody>
          </table>
        </div>
        <DataTable-table-footer
          *ngIf="footer && currentColumns.length > 0"
          [page]="page"
          [currentColumns]="currentColumns"
          [allColumns]="columns"
          [filter]="filter"
          [localPaging]="localPaging"
          [localPagingSize]="localPagingSize"
          [localPagingOptions]="localPagingOptions"
          [showLocalPagingOptions]="showLocalPagingOptions"
          [notifierService]="notifierService"
          [tableId]="tableId"
          [leftSideFooterTemplate]="footerLeftTemplate"
          [rightSideFooterTemplate]="footerRightTemplate"
          (filterChange)="headerChange($event)"
          (paginationChange)="changePage($event)"
        ></DataTable-table-footer>
      </ng-container>
    </div>
    <div *ngIf="displayTableEmptyAsPlainText()" class="empty-table">
      {{ tableEmptyMessage }}
    </div>
  `, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], function () { return [{ type: i1.DataTableUtils }]; }, { headerInfoComponent: [{
            type: ViewChild,
            args: [DataTableInfoHeaderComponent]
        }], headerComponent: [{
            type: ViewChild,
            args: [DataTableHeaderComponent]
        }], footerComponent: [{
            type: ViewChild,
            args: [DataTableFooterComponent]
        }], headerLeftTemplate: [{
            type: ContentChild,
            args: ['headerLeft', { static: true }]
        }], headerRightTemplate: [{
            type: ContentChild,
            args: ['headerRight', { static: true }]
        }], footerLeftTemplate: [{
            type: ContentChild,
            args: ['footerLeft', { static: true }]
        }], footerRightTemplate: [{
            type: ContentChild,
            args: ['footerRight', { static: true }]
        }], tableId: [{
            type: Input
        }], tableCssClass: [{
            type: Input
        }], data: [{
            type: Input
        }], columns: [{
            type: Input
        }], caption: [{
            type: Input
        }], hideCaption: [{
            type: Input
        }], columnPicker: [{
            type: Input
        }], columnOrdering: [{
            type: Input
        }], linkTarget: [{
            type: Input
        }], linkKey: [{
            type: Input
        }], sortable: [{
            type: Input
        }], filterable: [{
            type: Input
        }], columnFiltering: [{
            type: Input
        }], localFilter: [{
            type: Input
        }], showFilterPlaceholders: [{
            type: Input
        }], localPaging: [{
            type: Input
        }], localPagingSize: [{
            type: Input
        }], localPagingOptions: [{
            type: Input
        }], showLocalPagingOptions: [{
            type: Input
        }], serverSideData: [{
            type: Input
        }], initialSort: [{
            type: Input
        }], cellStylingFunction: [{
            type: Input
        }], childRows: [{
            type: Input
        }], childComponent: [{
            type: Input
        }], pageChange: [{
            type: Output
        }], columnChange: [{
            type: Output
        }], disableColumnChangeEvent: [{
            type: Input
        }], filter: [{
            type: Input
        }], footer: [{
            type: Input
        }], tableEmptyMessage: [{
            type: Input
        }], tableEmptyAsPlainText: [{
            type: Input
        }], suppressAnnouncement: [{
            type: Input
        }], rowStylingFunction: [{
            type: Input
        }] }); })();
